import Vue from 'vue';
import App from './components/App.vue';
import { router } from './router';
import store from './store';
import i18n from './i18n';

let MainApp = null;

const getApp = () => MainApp;

export default getApp;

export const loadApp = () => {
    /* eslint-disable vue/require-name-property */
    /* eslint-disable vue/padding-lines-in-component-definition */
    MainApp = new Vue({
        render: h => h(App),
        router,
        store,
        i18n
    }).$mount('app');
};
